import React, {useEffect, useState} from 'react'
import styled from '@emotion/styled'
import { PageCrumbs } from 'components'

const StyledDashBoardTop = styled.div({
	marginBottom: 10
})



const DashboardTop = () => {
	
	return (
		<StyledDashBoardTop>
			<PageCrumbs crumbs={[{ name: 'Dashboard', icon: 'appstore' }]} />
		</StyledDashBoardTop>
	)
}

export default DashboardTop
